<template>
  <div class="row my-5">
    <div
      v-for="(demo, index) in classify"
      :key="index.demo"
      style="background-color: #ffffff"
      :class="{
        'col-lg-4': true,
        'col-sm-4': true,
        'mb-5': true,
        card: true,
        PreEcolier: index === 0,
        Ecolier: index === 1,
        Benjamin: index === 2,
        Cadet: index === 3,
        Junior: index === 4,
        Student: index === 5,
      }"
    >
      <h3>{{ classify[index].text }}</h3>

      <div class="card-text">
        {{ topic[index].text
        }}<a
          v-show="!topic[index].isactive"
          class="read-button"
          @click="readMore(index)"
        >
          ...</a
        ><a v-show="topic[index].isactive">{{ topic[index].more }}</a>
      </div>
      <b-link
        :class="{
          'task-link btn btn-default': true,
          PreEcolier: index === 0,
          Ecolier: index === 1,
          Benjamin: index === 2,
          Cadet: index === 3,
          Junior: index === 4,
          Student: index === 5,
        }"
        :to="{
          name: 'LevelStageDemo',
          params: { cid: index + 1 },
        }"
      >
        Бодлого
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCom",
  data: function () {
    return {
      topic: [
        {
          isactive: false,
          text:
            "Зүй тогтлыг олох, нэг ба хоёр оронтой тоог нэмэх, дүрсийг таних, минут",
          more: ", цаг, өдөр, 7 хоног, сар, жил",
        },
        {
          isactive: false,
          text:
            "1000 доторх тооны нэмэх, хасах, үржих, хуваах үйлдлүүд, геометрийн дүрс ",
          more:
            "таних, олонлогийн огтлолцол, квадрат ба тэгш өнцөгтийн периметр болон талбайг олох",
        },
        {
          isactive: false,
          text:
            "Энгийн болон аравтын бутархай, олон өнцөгтийн периметр, тэгш өнцөгт ба ",
          more:
            "гурвалжны талбайг олох, логик, шулуун ба цацраг, куб, тэгш өнцөгт параллелопипед, хурц өнцөг, тэгш өнцөг, мохоо өнцөг",
        },
        {
          isactive: false,
          text:
            "Рациональ тооны үйлдлүүд, натурал тооны зэрэг, тэгшитгэл, тэнцэтгэл биш",
          more:
            ", шугаман тэгшитгэлийн систем, тойргийн талбай, биетийн эзэлхүүн ба гадаргуугийн талбай, гурвалжин ба тэгш өнцөгтийн дотоод өнцгийн нийлбэр",
        },
        {
          isactive: false,
          text:
            "Бодит тоон дээрх үйлдлүүд, функц, олон гишүүнт, тоон дараалал, комбина",
          more: "торикийн элементүүд, координатын геометр",
        },
        { isactive: false, text: "Логарифм, тригонометр, магадлал" },
      ],
      classify: [
        { text: "1-2-р анги" },
        { text: "3-4-р анги" },
        { text: "5-6-р анги" },
        { text: "7-8-р анги" },
        { text: "9-10-р анги" },
        { text: "11-12-р анги" },
      ],
    };
  },
  methods: {
    readMore: function (index) {
      this.topic[index].isactive = true;
    },
  },
};
</script>
<style lang="postcss" scoped>
.row {
  font-family: "Roboto", sans-serif;
  max-width: 1230px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  padding-bottom: 50px;
}

.PreEcolier {
  border-color: #e1745b;
  color: #d74726;
  background-color: #d74726;
}
.Ecolier {
  border-color: #f39317;
  color: #f48712;
  background-color: #f48712;
}
.Benjamin {
  border-color: #52b700;
  color: #52b700;
  background-color: #7ac73b;
}
.Cadet {
  border-color: #8a32a7;
  color: #8a32a7;
  background-color: #8a32a7;
}
.Junior {
  border-color: #00b971;
  color: #00b971;
  background-color: #00b971;
}
.Student {
  border-color: #00a1de;
  color: #00a1de;
  background-color: #00a1de;
}
h3 {
  text-align: center;
}
.card {
  width: 100%;
  border-radius: 1.875em;
  max-width: 380px;
  padding: 15px;
  display: flex;
  align-items: center;
  min-width: 280px;
  margin: 15px;
  position: relative;
}
.card > .card-text {
  color: #000;
  font-size: 0.9em;
  min-height: 110px;
}
.task-link {
  color: #ffffff;
  font-size: 1.25em;
  padding: 5px;
  font-weight: Bold;
  border-radius: 0.625em;
  min-width: 145px;
}
.task-link:hover {
  text-decoration: none;
}
.read-button {
  cursor: pointer;
  color: #000;
}
.read-button:hover {
  text-decoration: none;
}
</style>
